export function Domanda() {
    return (
        <>
            <div className="general-page-shadow">
                <img src="./Screenshot_20221111_131339.png"/>
            </div>
        </>
    )
}